/**
 * 場面の絵 (字の無い絵)。明るい版と暗い版の 2 枚を並べ、暗い版の LgRoot では暗い版の絵だけを出す
 * (地と丘を墨に寄せた別の絵。明るさを落とすだけの filter では地が浮くため)。出す枚の切り替えは lg.css の lg-art-light と lg-art-dark
 * src は明るい版の住所。暗い版は「名前-日付.svg」を「名前-dark-日付.svg」にした住所
 */
export function darkSceneSrc(src: string): string {
  return src.replace(/(-\d{4}-\d{2}-\d{2})\.svg$/, "-dark$1.svg");
}

export function LgSceneImg({ src, className = "", dataScene, width = 1200, height = 675 }: { src: string; className?: string; dataScene?: string; width?: number; height?: number }) {
  const common = { alt: "", width, height, loading: "lazy" as const, decoding: "async" as const, "data-scene": dataScene };
  return (
    <>
      <img className={`${className} lg-art-light`} src={src} {...common} />
      <img className={`${className} lg-art-dark`} src={darkSceneSrc(src)} {...common} />
    </>
  );
}
